<div class="dialog-header">
  <div class="dialog-title">
    <h1>
      {{ id ? ("editFamily" | translate) : ("newFamily" | translate) }}
    </h1>
  </div>

  <a href="javascript:;" class="dialog-close" (click)="close()"
    ><i class="fal fa-times"></i
  ></a>
</div>

<div class="dialog-content">
  <nz-spin [nzSpinning]="isLoading">
    <form nz-form nzLayout="vertical" [formGroup]="form" (submit)="save()">
      <nz-form-item>
        <nz-form-label nzFor="representative" nzRequired>{{
          "representative" | translate
        }}</nz-form-label>
        <nz-form-control>
          <input
            nz-input
            formControlName="representative"
            id="representative"
            [placeholder]="'representative' | translate"
          />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="phone" nzRequired>{{
          "phone" | translate
        }}</nz-form-label>
        <nz-form-control>
          <input
            nz-input
            formControlName="phone"
            id="phone"
            [placeholder]="'phone' | translate"
          />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="address" nzRequired>{{
          "address" | translate
        }}</nz-form-label>
        <nz-form-control>
          <input
            nz-input
            formControlName="address"
            id="address"
            [placeholder]="'address' | translate"
          />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="city">{{
          "city" | translate
        }}</nz-form-label>
        <nz-form-control>
          <input
            nz-input
            formControlName="city"
            id="city"
            [placeholder]="'city' | translate"
          />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="residence">{{
          "residence" | translate
        }}</nz-form-label>
        <nz-form-control>
          <input
            nz-input
            formControlName="residence"
            id="residence"
            [placeholder]="'residence' | translate"
          />
        </nz-form-control>
      </nz-form-item>


      <nz-form-item>
        <nz-form-label nzFor="documents">{{
          "documents" | translate
        }}</nz-form-label>
        <nz-form-control >
          <nz-select formControlName="documents">
            <nz-option
              [nzValue]= 'true'
              [nzLabel]="'DA' | translate"
            ></nz-option>
            <nz-option
              [nzValue]= 'false'
              [nzLabel]="'NE' | translate"
            ></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <div class="mt-4">
        <button nz-button nzType="primary" type="submit" [nzLoading]="isSaving">
          {{ id ? ("saveChanges" | translate) : ("add" | translate) }}
        </button>
        <button
          nz-button
          (click)="close()"
          type="button"
          class="ml-2"
          [disabled]="isSaving"
        >
          {{ "cancel" | translate }}
        </button>
      </div>
    </form>
  </nz-spin>
</div>
